import { motion } from "framer-motion";
import { Quote, Play } from "lucide-react";
import { useState, useEffect } from "react";
import mayaSchmidImg from "@/assets/testimonials/maya-schmid.jpg";
import carolHandalImg from "@/assets/testimonials/carol-handal.jpeg";
import carlosChapmanImg from "@/assets/testimonials/carlos-chapman.jpg";
import johanaHernandezImg from "@/assets/testimonials/johana-hernandez.jpeg";
import marlonAngelesImg from "@/assets/testimonials/marlon-angeles.webp";
import carolinaIsaacImg from "@/assets/testimonials/carolina-isaac.webp";
import silvanaRattiImg from "@/assets/testimonials/silvana-ratti.webp";
import jorgeVarelaImg from "@/assets/testimonials/jorge-leiva-varela.webp";
import safeZoneImg from "@/assets/testimonials/safe-zone.webp";

const testimonials = [{
  quote: "Es increíble contar con esta mentoría, me permitió tomar decisiones claves con más fuerza y mostrarme con autenticidad y seguridad.",
  name: "Maya Schmid",
  role: "Assistant Director · The Coca-Cola Company",
  location: "México 🇲🇽",
  image: mayaSchmidImg
}, {
  quote: "Gracias por expandir mi mirada, los elegí por tercera vez consecutiva porque me han dado el apoyo y acompañamiento realmente has hecho un gran cambio en mi vida y lo agradezco muchísimo.",
  name: "Carol Handal",
  role: "Empresaria",
  location: "Honduras 🇭🇳",
  image: carolHandalImg
}, {
  quote: "El proceso que llevamos adelante para mí fue súper muy valioso. Me llevo no solo herramientas, sino también una disciplina, una rutina para poder estructurar el proceso comunicacional de mi marca.",
  name: "Carlos Chapman",
  role: "Empresario",
  location: "México 🇲🇽",
  image: carlosChapmanImg
}, {
  quote: "Cada sesión fue un encuentro profundo y de mucho aprendizaje, me ayudó a desbloquear miedo y tener resultados que antes no imaginaba tener.",
  name: "Johana Hernandez",
  role: "Empresaria",
  location: "Venezuela 🇻🇪",
  image: johanaHernandezImg
}, {
  quote: "Recibí mucho más de lo que esperaba! Desde el día uno aprendí cómo desbloquear muros mentales que yo mismo había creado. Logré desarrollar una ruta clara para mi marca personal con herramientas para mejorar mi presencia digital.",
  name: "Marlon Angeles",
  role: "Empresario",
  location: "Perú 🇵🇪",
  image: marlonAngelesImg
}, {
  quote: "Grandes profesionales que supieron escuchar y hacer realidad mi sueño!!",
  name: "Carolina Issac",
  role: "Fotógrafa",
  location: "Argentina 🇦🇷",
  image: carolinaIsaacImg
}, {
  quote: "¡Tremendo! Fuimos escalando y descubriendo nuevas facetas, que uno tal vez no lo tenía como un plan dentro de la empresa, así que estuvo buenísimo este descubrimiento.",
  name: "Silvana Ratti",
  role: "Empresa Constructora",
  location: "Argentina 🇦🇷",
  image: silvanaRattiImg
}, {
  quote: "Este año con ustedes ha sido para mí muy, muy, pero muy hermoso, muy importante. Fue un descubrimiento. Cuando digo que nuestras posibilidades se expanden, realmente creo en eso.",
  name: "Claudia Ferrara",
  role: "Caminando con Propósito",
  location: "Argentina 🇦🇷"
}, {
  quote: "Gracias por todo! Es impresionante su trabajo y estamos muy felices de haberlos conocido!!!",
  name: "Jorge Leiva Varela",
  role: "Oralix",
  location: "Argentina 🇦🇷",
  image: jorgeVarelaImg
}, {
  quote: "Queremos agradecer al equipazo, sin este hermoso capital humano no hubiéramos llegado a lo que hoy somos. Los recomiendo siempre a todas aquellas personas que quieran tener Marcas con valores.",
  name: "Ale y Emi",
  role: "Safe Zone",
  location: "Argentina 🇦🇷",
  image: safeZoneImg
}];

const videoTestimonials = [{
  name: "Silvana Ratti",
  role: "Empresaria Real Estate",
  location: "Argentina",
  videoId: "XZzlQnD4Hx4",
  isShort: true
}, {
  name: "Alejandro y Emilia",
  role: "PASTUNGUI",
  location: "Argentina",
  videoId: "vPncvlA9Zyw",
  isShort: true
}, {
  name: "Sabrina Spinelli",
  role: "ÓPTICA SPINELLI",
  location: "Argentina",
  videoId: "01FW2_HmJjw",
  isShort: true
}, {
  name: "Sergio Mur",
  role: "DANEVA",
  location: "Argentina",
  videoId: "Y_UrBPTLRik",
  isShort: true
}];

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="testimonios" className="py-24 md:py-32 relative overflow-hidden bg-background">
      {/* Background pattern */}
        <div className="absolute inset-0 opacity-8">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 1px 1px, hsl(270 45% 55%) 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} />
      </div>

      <div className="container px-4 relative z-10">
        {/* Video testimonials section - NOW FIRST */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-muted-foreground text-sm font-semibold tracking-[0.3em] uppercase mb-6 block">
            Testimonios
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground">
            Historias de <span className="text-primary">Transformación</span>
          </h2>
        </motion.div>

        {/* Video grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {videoTestimonials.map((video, index) => (
            <motion.div
              key={video.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <div className="bg-card rounded-2xl overflow-hidden border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-lg">
                <div className={`relative ${video.isShort ? 'aspect-[9/16]' : 'aspect-video'}`}>
                  <iframe
                    src={`https://www.youtube-nocookie.com/embed/${video.videoId}`}
                    title={`Testimonio de ${video.name}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="absolute inset-0 w-full h-full"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-foreground">{video.name}</h3>
                  <p className="text-sm text-muted-foreground">
                    {video.role} · {video.location}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Written testimonials - NOW SECOND, COMPACT CAROUSEL */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-8"
        >
          <h3 className="font-display text-2xl md:text-3xl font-bold">
            Lo que dicen <span className="text-gradient-gold">nuestros clientes</span>
          </h3>
        </motion.div>

        {/* Compact rotating testimonial */}
        <div className="max-w-2xl mx-auto">
          <motion.div
            key={activeIndex}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.4 }}
            className="bg-card/50 rounded-xl p-6 relative border border-border/50"
          >
            <Quote className="w-6 h-6 text-primary/30 absolute top-4 left-4" />
            
            <div className="flex items-center gap-4">
              {testimonials[activeIndex].image && (
                <div className="shrink-0">
                  <div className="w-12 h-12 rounded-full overflow-hidden border border-primary/30">
                    <img
                      src={testimonials[activeIndex].image}
                      alt={testimonials[activeIndex].name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              )}
              
              <div className="flex-1 text-left">
                <p className="text-sm md:text-base text-foreground/90 mb-2 line-clamp-2">
                  "{testimonials[activeIndex].quote}"
                </p>
                <p className="text-primary font-medium text-sm">
                  {testimonials[activeIndex].name}
                  <span className="text-muted-foreground font-normal ml-2">
                    {testimonials[activeIndex].role}
                  </span>
                  {testimonials[activeIndex].location && (
                    <span className="text-muted-foreground font-normal ml-2">
                      · {testimonials[activeIndex].location}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Navigation dots */}
          <div className="flex justify-center gap-2 mt-4">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === activeIndex
                    ? 'bg-primary w-6'
                    : 'bg-muted-foreground/30 hover:bg-muted-foreground/50'
                }`}
                aria-label={`Ver testimonio ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;